import { type FilterResult } from '@components/Home/HomePageSearchModal'
import { contentLibrary } from '@components/shared/consts'

export const defaultSearchResultWithoutKuran: FilterResult[] = [
  { name: 'Cevşen-i Şerif', keywords: 'cevsen cevseni serif ', url: '/cevsen' },
  { name: 'Zikirmatik', keywords: 'zikir tesbih', url: '/zikirmatik' },
  {
    name: 'Evrad-ı Kudsiye',
    keywords: 'evradi kudsiye dua',
    url: '/dualar/evrad-i-kudsiye',
  },
  {
    name: 'Not Defteri',
    url: '/not-defteri',
    keywords: 'not defteri notebook',
  },
  {
    name: 'Ortak Hatim',
    url: '/ortak-hatim',
    keywords: 'ortak hatim kuran hatim',
  },
  {
    name: 'Sila-i Rahim Takibi',
    url: '/sila-i-rahim-takibi',
    keywords: 'sila-i rahim akraba ziyaret hatirlatici alarm hatirlatma bildirim takip',
  },
  {
    name: 'Sizden Gelen Dualar',
    url: '/sizden-gelen-dualar',
    keywords: 'sizden gelen dualar dua',
  },
]

const homeDefaultSearchResult = [
  ...contentLibrary
    .filter((item) => item.basePath)
    .map((item) => ({
      name: item.name,
      url: `/${item.url}`,
      keywords: item.keywords,
    })),
  ...defaultSearchResultWithoutKuran,

  { name: '22. Cüz', url: '/kuran/422', keywords: 'kuran cuz' },
  { name: 'Yâsin Suresi', url: '/kuran/439#sure-36', keywords: 'yasin suresi kuran' },
  { name: 'Fetih Suresi', url: '/kuran/510#sure-48', keywords: 'fetih suresi kuran' },
  { name: 'Vakıa Suresi', url: '/kuran/533#sure-56', keywords: 'vakia suresi kuran' },
]

export default homeDefaultSearchResult
